var map = {
	"./menu-icon1-s.png": 73943,
	"./menu-icon2-s.png": 64932,
	"./menu-icon3-s.png": 43097,
	"./menu-icon4-s.png": 54966,
	"./menu-icon5-s.png": 99507,
	"./menu-icon6-s.png": 75776,
	"./menu-icon7-s.png": 56197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50645;